/* @jsxImportSource react */

// TODO: FETW-41 use actual responsive layout to get the background lines to the window borders and stuff
// TODO: FETW-41 support both legacy and new navigation

export const ResponsiveNavigationLoading = () => (
  <>
    {/* h-6 is necessary because, for unknown reasons, otherwise the height with 32px content and 8px padding results in 52px total height instead of the intended 48px */}
    <div className="h-6 cursor-wait p-1 lg:hidden">
      <div className="icon-emp-burger-text-32 text-color-grey h-4 w-4 animate-pulse" />
    </div>
    <div className="border-color-grey flex h-[calc(2.75rem+2px)] items-center border-y max-lg:hidden">
      {Array.from({ length: 10 }).map(() => (
        <div className="bg-color-grey-light text-size-body1 mx-1 h-[1em] flex-1 animate-pulse rounded-sm" />
      ))}
    </div>
  </>
);
